import MAIndicesPage from './MAIndicesPage'
// Uncomment the below to migrate to stateful component
// import MAIndicesPageContainer from './MAIndicesPageContainer'

export { MAIndicesPage }
export default MAIndicesPage
// Uncomment the below to migrate to stateful component
// export { MAIndicesPageContainer }
// export default { MAIndicesPageContainer }
